/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Collectionindex_Title1Inputs */

const en_seo_collectionindex_title1 = /** @type {(inputs: Seo_Collectionindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const zh_seo_collectionindex_title1 = /** @type {(inputs: Seo_Collectionindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选合集`)
};

/**
* | output |
* | --- |
* | "Collections" |
*
* @param {Seo_Collectionindex_Title1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_collectionindex_title1 = /** @type {((inputs?: Seo_Collectionindex_Title1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Collectionindex_Title1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_collectionindex_title1(inputs)
	return zh_seo_collectionindex_title1(inputs)
});
export { seo_collectionindex_title1 as "seo.collectionIndex.title" }